import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    activeStableTab: 'Horse stats',
    activeStableTabJockey: 'Total stats',
    activeStarStable: 'horses',
    activeStableButton: false
};
const tabs = createSlice({
    name: 'Stable',
    initialState,
    reducers: {
        setActiveStableTab: (state, action) => {
            state.activeStableTab = action.payload;
        },
        setActiveStableJockeyTab: (state, action) => {
            state.activeStableTabJockey = action.payload;
        },
        setActiveStarStableTab: (state, action) => {
            state.activeStarStable = action.payload;
        },
        setActiveStableButton: (state, action) => {
            state.activeStableButton = action.payload;
        }
    }
});
export const { setActiveStarStableTab, setActiveStableButton, setActiveStableTab, setActiveStableJockeyTab } = tabs.actions;
export default tabs.reducer;
